import React, { useState, useEffect } from 'react';
import { ListGroup, Button } from 'react-bootstrap';

function MatchHistory({ onSelectReplay, onBack }) {
    const [replays, setReplays] = useState([]);

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem('chess-replays') || '[]');
        setReplays(saved);
    }, []);

    return (
        <div className="p-2 text-white w-100">
            <h4 className="text-center mb-3">Match History</h4>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {replays.length === 0 ? (
                    <p className="text-center text-muted">No games saved.</p>
                ) : (
                    <ListGroup variant="flush">
                        {replays.map((game) => (
                            <ListGroup.Item key={game.id} className="bg-dark-transparent text-white border-secondary d-flex justify-content-between align-items-center px-2">
                                <div>
                                    <div className="small"><strong>{game.date}</strong></div>
                                    <div style={{fontSize: '0.75rem'}} className="text-muted">{game.moves.length} moves</div>
                                </div>
                                <Button variant="outline-success" size="sm" onClick={() => onSelectReplay(game)}>Watch</Button>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}
            </div>
            <Button variant="outline-light" className="w-100 mt-3" onClick={onBack}>Back</Button>
        </div>
    );
}
export default MatchHistory;